import sectionCardMultiToolCss from '../css-snippets/section-card-multi-tool';

const html = `
<style>${sectionCardMultiToolCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#FFFFFF"
  data-top-padding="false" data-bottom-padding="false" style="background-color: rgb(255, 255, 255);">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-enable-border="true" data-border-color="#d4dceb" data-attribute="card-item-content" data-order="1"
          class="card-left" data-style-center-y="false" style="border: 1px solid #d4dceb;">
          <div data-attribute="card-rated-row" data-show-rating="false" style="display: none;">
            <div class="wrap-rated">
              <div data-attribute="rating-stars" data-value="4" class="wrap-stars">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                  <!---->
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                  </path>
                  <!----><!----><!---->
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                  <!---->
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                  </path>
                  <!----><!----><!---->
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                  <!---->
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                  </path>
                  <!----><!----><!---->
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                  <!---->
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                  </path>
                  <!----><!----><!---->
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                  <!---->
                  <path
                    d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                  </path>
                  <!----><!----><!---->
                </svg>
              </div>
              <div data-attribute="rating-text" class="wrap-rating" data-text-color="#000000" style="color: #000000;">
                Rated 4.9/5 by 12,000+ happy
                owners
              </div>
            </div>
          </div>
          <div data-attribute="card-content" class="card-content" data-text-color="">
            <p><span>Driven by a passion for innovation and a desire to help people find genuine relief, we spent
                years
                developing and perfecting the Hizoo massager. The result is a patented four-prong design that is a
                quantum leap forward in massage technology.</span></p>
          </div>
          <div data-attribute="card-accordions" data-show-accordion="true" style="display: block;">
            <div data-attribute="card-accordion" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Post-Surgery (e.g., Prostate)</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">
                  Perfect for recovery after prostate or bladder surgery. Our soft, breathable bamboo won't irritate
                  sensitive skin, while our 9-layer system handles post-op leaks discreetly. Recover with dignity and
                  comfort.
                </div>
              </div>
            </div>
            <div data-attribute="card-accordion" data-show-accordion="true" class="wrap-accordion">
              <div data-attribute="accordion-title" class="accordion-title">
                <div data-attribute="accordion-title-text">Guarantee Details</div>
                <div class="accordion-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-down-icon lucide-chevron-down">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </div>
              </div>
              <div data-attribute="accordion-content" class="accordion-content">
                <div data-attribute="accordion-text" class="accordion-text">We're so confident in AlphaInfuse™ that we
                  don't
                  want you to spend a dime until you're 100% sure it works for you.
                </div>
              </div>
            </div>
          </div>

          <div data-attribute="wrap-item-with-icon" data-show-item-with-icon="true" class="wrap-item-with-icon"
            style="display: block;">
            <div data-attribute="item-with-icon" class="wrap-item">
              <div class="wrap-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="wrap-tex-icon">
                <div class="title-icon">Quick Dispatch, anywhere in the world</div>
                <div class="description-icon">Made with sustainable bamboo, so you can feel good about what you're
                  wearing.</div>
              </div>
            </div>
            <div data-attribute="item-with-icon" class="wrap-item">
              <div class="wrap-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="wrap-tex-icon">
                <div class="title-icon">Ethically Sourced Bamboo</div>
                <div class="description-icon">Made with sustainable bamboo, so you can feel good about what you're
                  wearing.</div>
              </div>
            </div>
            <div data-attribute="item-with-icon" class="wrap-item">
              <div class="wrap-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="wrap-tex-icon">
                <div class="title-icon">45 Day Money Back Guarantee</div>
                <div class="description-icon">Made with sustainable bamboo, so you can feel good about what you're
                  wearing.</div>
              </div>
            </div>
            <div data-attribute="item-with-icon" class="wrap-item">
              <div class="wrap-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="wrap-tex-icon">
                <div class="title-icon">24/7 Support for all of your inquiries</div>
                <div class="description-icon">Made with sustainable bamboo, so you can feel good about what you're
                  wearing.</div>
              </div>
            </div>
            <div data-attribute="item-with-icon" class="wrap-item">
              <div class="wrap-icon">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                  alt="">
              </div>
              <div class="wrap-tex-icon">
                <div class="title-icon">SSL Encryption for Safe & Secure Payments</div>
                <div class="description-icon">Made with sustainable bamboo, so you can feel good about what you're
                  wearing.</div>
              </div>
            </div>
          </div>

          <div data-attribute="images-small" data-show-imgsmall="true" class="group-images-small">
            <div class="item-img">
              <video width="100%" height="auto" autoplay muted loop playsinline>
                <source data-attribute="video-small" type="video/mp4"
                  src="https://cdn-cf-east.streamable.com/video/mp4/4n6e0p.mp4?Expires=1774780504757&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ&Signature=UtCbeXPzSZhjgeANxHlN4CV35TgAwdG7PD8QsRibeUzKvhQXnrJBUtdev3bU1twzB0A-u5DzqObYYe~XBleoEks92T1kz--q6CifotdVOPDvfJP9V-agzCI1Qb3JRq4h0QN1aAWPGUJCXMqO8UxxlB52VMeT-20O6hPl4SX3Ps0nh4V3T1uR-hmbN5ABTbIsUbiyKx7JJFutZon56OEAPpEZVcdDD~FPIECNWSF3YrI~RSK0tCY5GLhLBACqUXq5n5WiLzBLEGaK~5yTxi35OyQFlosQbVlWLXgokofvX~pcX7EFSyKHmdSRk839iKOSZBUIBU--PvJuM1FdXKU20A__">
              </video>

              <div data-show-icon="true" data-attribute="data-icon-small" class="icon-img-smal">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb85302e2e41c4bd0935f6.png?w=50&h=50&q=80"
                  alt="">
              </div>
            </div>
            <div class="item-img">
              <img data-attribute="image-small" loading="lazy"
                src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba6f602e4bb7019e5c33da.gif?w=50&h=50&q=80"
                alt="">
              <div data-show-icon="true" data-attribute="data-icon-small" class="icon-img-smal">
                <img
                  src="https://cdn.skyfastimg.com/images/2026/03/31/image-69cb85302e2e41c4bd0935f6.png?w=50&h=50&q=80"
                  alt="">
              </div>
            </div>
          </div>

          <div data-attribute="card-btn-row" data-show-btn="true" class="row-btn" style="display: block;">
            <a data-attribute="card-btn" class="card-btn" href="#" data-radius="0" data-background="#F35C5C"
              data-color="#ffffff" style="background-color: #F35C5C; color: #ffffff">
              <span data-attribute="btn-text">get your now</span>
              <div class="icon-btn">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0L3.51 4.78636L0 9.57273H2.34L5.85 4.78636L2.34 0H0Z" fill="currentColor" />
                </svg>

              </div>
            </a>
            <div data-attribute="sub-btn" class="sub-btn" data-text-color=""></div>
          </div>
        </div>
        <div data-attribute="card-item-image" data-order="2" class="card-right" style="order: 2;">
          <div data-show-img="false" data-attribute="wrap-img" data-radius="0" class="wrap-img" style="display: none;">
            <img src="https://cdn.skyfastimg.com/images/2026/03/18/image-69ba18fe5db9fdba973abc6b.png?w=600&h=50&q=80"
              alt="">
          </div>
          <div data-show-video="true" data-attribute="wrap-video" class="wrap-video">
            <video width="100%" height="auto" autoplay muted loop playsinline>
              <source data-attribute="card-video" type="video/mp4"
                src="https://cdn-cf-east.streamable.com/video/mp4/4n6e0p.mp4?Expires=1774780504757&Key-Pair-Id=APKAIEYUVEN4EVB2OKEQ&Signature=UtCbeXPzSZhjgeANxHlN4CV35TgAwdG7PD8QsRibeUzKvhQXnrJBUtdev3bU1twzB0A-u5DzqObYYe~XBleoEks92T1kz--q6CifotdVOPDvfJP9V-agzCI1Qb3JRq4h0QN1aAWPGUJCXMqO8UxxlB52VMeT-20O6hPl4SX3Ps0nh4V3T1uR-hmbN5ABTbIsUbiyKx7JJFutZon56OEAPpEZVcdDD~FPIECNWSF3YrI~RSK0tCY5GLhLBACqUXq5n5WiLzBLEGaK~5yTxi35OyQFlosQbVlWLXgokofvX~pcX7EFSyKHmdSRk839iKOSZBUIBU--PvJuM1FdXKU20A__">
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
